import React, { useState } from 'react';
import withRoleAccess from '../../hoc/withRoleAccess';
import '../Dashboard.css';
import { useTranslation } from 'react-i18next';
import { Modal, Form, Input, InputNumber, Select, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

function ClassroomModal({ isOpen, onClose, onSave, classroomData }) {
  const { t } = useTranslation();
  const [classroom, setClassroom] = useState({
    number: classroomData?.number || '',
    capacity: classroomData?.capacity || '',
    availability: classroomData?.availability || true,
  });

  const handleChange = (name, value) => {
    setClassroom({ ...classroom, [name]: value });
  };

  const handleSubmit = () => {
    onSave(classroom); 
  };

  return (
    <Modal
      title={classroomData ? t('Edit Classroom') : t('Create Classroom')}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      className="classroom-modal"
    >
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item label={t('number')}>
          <Input 
            value={classroom.number} 
            onChange={(e) => handleChange('number', e.target.value)}
          />
        </Form.Item>
        
        <Form.Item label={t('capacity')}>
          <InputNumber
            min={1}
            value={classroom.capacity}
            onChange={(value) => handleChange('capacity', value)}
            style={{ width: '100%' }}
          />
        </Form.Item>
        
        <Form.Item label={t('availability')}>
          <Select
            value={classroom.availability}
            onChange={(value) => handleChange('availability', value)}
            style={{ width: '100%' }}
          >
            <Select.Option value={true}>{t('available')}</Select.Option>
            <Select.Option value={false}>{t('notAvailable')}</Select.Option>
          </Select>
        </Form.Item>
        
        <div className="modal-actions">
          <Button type="primary" htmlType="submit">
            {t('save')}
          </Button>
          <Button onClick={onClose} style={{ marginLeft: 8 }}>
            {t('cancel')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default withRoleAccess(ClassroomModal, ['admin', 'superadmin']);